import { observer } from 'mobx-react';
import { useStore } from '../../../app/data/root.store';
import { getDocTypeIcon } from "../../assets/docsTypes/docTypes"
import { VaultOptionsIcon } from "../../assets/icons"
import { VaultListTags } from "../VaultListTags/VaultListTags"
import { VaultStatusMap } from "../VaultStatuses/VaultStatusMap"
import { VaultListItemDataItem, VaultListItemDataWrapper, VaultListItemOptionsIconWrapper, VaultListItemTitleWrapper, VaultListItemTitleWrapperText, VaultListItemWrapper } from "./VaultListItem.styles"
import { ItemSelectedCheckbox } from '../../../wealth/pages/class/components/ClassPage.styles';
import { VaultItemSelectedCheckboxWrapper } from '../VaultList/VaultList.styles';

const ItemSelectedIcon = () => (
    <svg width="8" height="8" viewBox="0 0 8 8" fill="none">
        <path d="m7 2-4 4L1 4" stroke="white" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
);

export const VaultListItem = observer(({ file }) => {
    const { vaultStore } = useStore();

    const handleItemClick = () => {
        if (vaultStore.isBulkEditMode) {
            vaultStore.addOrRemoveFileForBulkEdit(file.id);
        } else {
            if (vaultStore.selectedFile?.id === file.id) {
                vaultStore.setSelectedFile(null);
            } else {
                vaultStore.setSelectedFile(file);
            }
        }
    };

    const handleCheckboxClick = (e) => {
        e.stopPropagation();
        vaultStore.addOrRemoveFileForBulkEdit(file.id);
    };

    const isSelected = !!vaultStore.selectedFile && vaultStore.selectedFile.id === file.id;
    const isSelectedForBulkEdit = vaultStore.selectedFilesForBulkEdit.includes(file.id);
    const vaultStatusIcon = VaultStatusMap(file.status, isSelected);
    const type = file.originalName.split('.').pop()?.toLowerCase();
    const displayName = file.displayName;

    return (
        <VaultListItemWrapper
            onClick={handleItemClick}
            isSelected={isSelected}
        >
            <VaultItemSelectedCheckboxWrapper
                data-checkbox
                onClick={handleCheckboxClick}
                isSelected={isSelectedForBulkEdit}
                isBulkEditMode={vaultStore.isBulkEditMode}
            >
                <ItemSelectedCheckbox isSelected={isSelectedForBulkEdit}>
                    {isSelectedForBulkEdit && <ItemSelectedIcon />}
                </ItemSelectedCheckbox>
            </VaultItemSelectedCheckboxWrapper>

            <VaultListItemTitleWrapper>
                <div style={{ flexShrink: 0 }}>{getDocTypeIcon(type)}</div>
                <VaultListItemTitleWrapperText>{displayName}</VaultListItemTitleWrapperText>
            </VaultListItemTitleWrapper>
            <VaultListItemDataWrapper>
                {
                    !isSelected &&
                    <VaultListTags file={file} />
                }
                <VaultListItemDataItem>{vaultStatusIcon}</VaultListItemDataItem>
            </VaultListItemDataWrapper>
            {
                !isSelected &&
                <VaultListItemOptionsIconWrapper>
                    <VaultOptionsIcon />
                </VaultListItemOptionsIconWrapper>
            }
        </VaultListItemWrapper>
    )
});